<div
	*ngIf="(supportedLanguages$ | async)?.length > 1" class="gap-menu__anchor" id="menu__anchor"
>
	<div
		#toggleDropdown
		tabindex="0"
		class="gap-icon__wrapper"
		(click)="clickToggleDropdown()"
	>
		{{ 'swaplanguage.display_' + currentLanguage | locale }}
		<gap-iconography
			*ngIf="isSideNav"
			gap-icon="small-arrow-down-solid"
		></gap-iconography>
		<!-- Login Page with different Icon color -->
		<gap-iconography
			*ngIf="!isSideNav"
			gap-color="secondary"
			gap-icon="small-arrow-down-solid"
		></gap-iconography>
		<gap-menu
			id="my-menu"
			data-cy="swapLanguage__menu--options"
			#optionsMenu
			[attr.gap-open]="swapLanguageOpen"
			gap-position="8"
		>
			<gap-menu-item
				[attr.data-cy]="'swapLanguage__menu-item--' + language.locale"
				*ngFor="let language of supportedLanguages$ | async"
				class="text--left"
				data-value="{{ language.name }}"
				(click)="swapLanguage(language.name)"
			>
				{{ 'swaplanguage.display_' + language.locale | locale }}
			</gap-menu-item>
		</gap-menu>
	</div>
</div>
